import { Component } from '@angular/core';
import { DefaultColumnComponent } from '../default-column/default-column.component';

@Component({
  selector: 'app-default-currency-column',
  templateUrl: './default-currency-column.component.html',
  styleUrls: ['./default-currency-column.component.scss']
})
export class DefaultCurrencyColumnComponent extends DefaultColumnComponent {
  /** Coerce a value that arrives as a numeric string ('12.5') to a number before it reaches
   *  `appCurrency`, which — unlike the string-coercing CurrencyPipe this column replaced —
   *  rejects non-number input (Number.isFinite) and would render an empty cell. This is the
   *  generic currency cell used across every list, so it is the widest surface for a field a
   *  future endpoint serializes as a quoted number. A non-numeric or empty value maps to null
   *  (appCurrency renders it as a blank cell, exactly as it did before). */
  getNumericValue(): number | null {
    const value = this.getValue();
    if (typeof value === 'number') {
      return Number.isFinite(value) ? value : null;
    }
    if (typeof value === 'string' && value.trim() !== '') {
      const n = Number(value);
      return Number.isFinite(n) ? n : null;
    }
    return null;
  }
}
